export const locations = ["stash", "workspace", "index", "local_repo", "remote_repo"]

export const commands = [
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "status",
    "key":       "status",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "status",
    "key":       "diff",
    "tags":      "Basic Snapshotting,Inspection and Comparison,Patching",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "status",
    "key":       "diff x",
    "tags":      "Basic Snapshotting,Inspection and Comparison,Patching",
  },
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "up",
    "key":       "add x",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "up",
    "key":       "add -u",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "up",
    "key":       "rm x",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "up",
    "key":       "mv x",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "up",
    "key":       "commit -a",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "index",
    "direction": "dn",
    "key":       "checkout x",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "index",
    "right":     "index",
    "direction": "status",
    "key":       "reset head x",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "local_repo",
    "right":     "local_repo",
    "direction": "status",
    "key":       "reset --soft head^",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "reset --hard",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "reset --hard x/x",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "switch",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "checkout -b x",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "merge x",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "rebase x",
    "tags":      "Patching",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "cherry-pick x",
    "tags":      "Patching",
  },
  {
    "left":      "workspace",
    "right":     "local_repo",
    "direction": "dn",
    "key":       "revert x",
  },
  {
    "left":      "index",
    "right":     "local_repo",
    "direction": "status",
    "key":       "diff --cached",
    "tags":      "Basic Snapshotting,Inspection and Comparison,Patching",
  },
  {
    "left":      "index",
    "right":     "local_repo",
    "direction": "up",
    "key":       "commit",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "index",
    "right":     "local_repo",
    "direction": "up",
    "key":       "commit --amend",
    "tags":      "Basic Snapshotting",
  },
  {
    "left":      "local_repo",
    "right":     "local_repo",
    "direction": "status",
    "key":       "log",
    "tags":      "Branching and Merging, Inspection and Comparison",
  },
  {
    "left":      "local_repo",
    "right":     "local_repo",
    "direction": "status",
    "key":       "diff x x",
    "tags":      "Basic Snapshotting, Inspection and Comparison,Patching",
  },
  {
    "left":      "local_repo",
    "right":     "local_repo",
    "direction": "status",
    "key":       "branch",
    "tags":      "Branching and Merging",
  },
  {"left": "remote_repo",
    "right": "remote_repo",
    "direction": "status",
    "key": "branch -r",
    "tags": "Branching and Merging"},
  {
    "left":      "local_repo",
    "right":     "local_repo",
    "direction": "status",
    "key":       "branch -d x",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "local_repo",
    "right":     "remote_repo",
    "direction": "dn",
    "key":       "branch --track x x",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "workspace",
    "right":     "remote_repo",
    "direction": "dn",
    "key":       "clone x",
    "tags":      "Creating Projects",
  },
  {
    "left":      "workspace",
    "right":     "remote_repo",
    "direction": "dn",
    "key":       "pull x x",
    "tags":      "Sharing and Updating",
  },
  {
    "left":      "local_repo",
    "right":     "remote_repo",
    "direction": "dn",
    "key":       "fetch x x",
    "tags":      "Sharing and Updating",
  },
  {
    "left":      "local_repo",
    "right":     "remote_repo",
    "direction": "up",
    "key":       "push",
    "tags":      "Sharing and Updating",
  },
  {
    "left":      "local_repo",
    "right":     "remote_repo",
    "direction": "up",
    "key":       "push x x",
    "tags":      "Sharing and Updating",
  },
  {
    "left":      "local_repo",
    "right":     "remote_repo",
    "direction": "up",
    "key":       "push x x:x",
    "tags":      "Sharing and Updating",
  },
  {
    "left":      "remote_repo",
    "right":     "remote_repo",
    "direction": "status",
    "key":       "push --delete",
    "tags":      "Sharing and Updating",
  },
  {
    "left":      "workspace",
    "right":     "workspace",
    "direction": "dn",
    "key":       "clean",
    "tags":      "Administration",
  },
  {
    "left":      "stash",
    "right":     "workspace",
    "direction": "dn",
    "key":       "stash push",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "workspace",
    "direction": "up",
    "key":       "stash pop",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "workspace",
    "direction": "up",
    "key":       "stash apply",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "stash",
    "direction": "status",
    "key":       "stash list",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "stash",
    "direction": "status",
    "key":       "stash show",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "stash",
    "direction": "status",
    "key":       "stash drop",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "stash",
    "direction": "status",
    "key":       "stash clear",
    "tags":      "Branching and Merging",
  },
  {
    "left":      "stash",
    "right":     "local_repo",
    "direction": "up",
    "key":       "stash branch x",
    "tags":      "Branching and Merging",
  },
]
